// Recipient defaults and checks for the meeting email (spec §3.5).
import { clientMatchers } from "./mail.js";
import { fullName } from "../utils/theme.js";

const EMAIL = /^[^@\s<>(),;:"]+@[^@\s<>(),;:"]+\.[^@\s<>(),;:"]{2,}$/;
export const isEmail = (s) => typeof s === "string" && EMAIL.test(s.trim());
const norm = (s) => String(s || "").trim().toLowerCase();
export const INVALID_EMAIL = "That doesn’t look like an email address.";

export function defaultRecipients({ pocs, project, users }) {
  const seen = new Set();
  const take = (address, name) => {
    const a = norm(address);
    if (!isEmail(a) || seen.has(a)) return null;
    seen.add(a);
    return { address: a, name: name || "" };
  };
  const to = (pocs || []).map((p) => take(p?.email, p?.name)).filter(Boolean);
  const ids = [project?.projectManager, project?.accountOwner ?? project?.projectOversight].filter(Boolean);
  const cc = ids.map((id) => (users || []).find((u) => u.id === id)).filter(Boolean)
    .map((u) => take(u.email, fullName(u))).filter(Boolean);
  return { to, cc };
}

export function addRecipient(list, address, otherList = []) {
  const a = norm(address);
  if (!isEmail(a)) return { ok: false, error: INVALID_EMAIL };
  if ([...list, ...otherList].some((r) => r.address === a)) return { ok: true, list };
  return { ok: true, list: [...list, { address: a, name: "" }] };
}

export function recipientCount({ to, cc }) {
  return new Set([...to, ...cc].map((r) => r.address)).size;
}

export function confirmLine(sel, pocs, clientName) {
  const { emails, domains } = clientMatchers(pocs || []);
  const all = [...new Set([...sel.to, ...sel.cc].map((r) => r.address))];
  const atClient = all.filter((a) => emails.has(a) || domains.has(a.split("@")[1])).length;
  const n = all.length;
  return `Send to ${n} ${n === 1 ? "person" : "people"} (${atClient ? atClient : "none"} at ${clientName})`;
}
